import React from 'react';
import { getSubCategoryId } from '../../../../../utils/DictionaryManagementUtils';
import ArrowInsideBigSquareBtn from '../../../AuxiliaryComponent/ButtonComponent/ArrowInsideBigSquareBtn';
import ParticipantContactList from '../../../../ContactList/ParticipantContactList';
import ParticipantDivisionComponent from '../../../../ParticipantDivisionComponent';
import FullPageSimulator from '../../FullPageSimulator';

const PaymentPerParticipantFP = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null, numberOfParticipants, withSelected,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { recipient } = globJSON.configurations.services[subCategoryId];
  if (slideshowRefs !== null && !recipient.select_from_recipients_list) {
    return null;
  }

  return (
    <FullPageSimulator
      globJSON={globJSON}
      slideshowRefs={slideshowRefs}
      simPlatform={simPlatform}
      headlineText={recipient.amount_participant_title}
      floatingChildren={(
        <ArrowInsideBigSquareBtn
          tintColor={colors.cta_font_color}
          backgroundColor={colors.primary_cta_color}
          simPlatform={simPlatform}
          isShapeSquare={globJSON.configurations.theme.radius.elements_shape_square}
        />
            )}
    >
      <ParticipantDivisionComponent
        globJSON={globJSON}
        totalAmount={100}
        numberOfParticipants={numberOfParticipants}
        totalAmountText={recipient.total_payment}
      />
      <ParticipantContactList globJSON={globJSON} simPlatform={simPlatform} withSelected={withSelected} />
    </FullPageSimulator>
  );
};

export default PaymentPerParticipantFP;
